import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
    const resolveRef = useRef(null);
    const [state, setState] = useState({
        open: false,
        title: '',
        message: '',
        confirmLabel: 'Po',
        cancelLabel: 'Jo',
        variant: 'danger',
    });

    const confirm = useCallback((options = {}) => {
        return new Promise((resolve) => {
            resolveRef.current = resolve;
            setState({
                open: true,
                title: options.title || 'Konfirmo',
                message: options.message || 'A jeni të sigurt?',
                confirmLabel: options.confirmLabel || 'Po',
                cancelLabel: options.cancelLabel || 'Jo',
                variant: options.variant || 'danger',
            });
        });
    }, []);

    const handleClose = useCallback((value) => {
        resolveRef.current?.(value);
        resolveRef.current = null;
        setState((s) => ({ ...s, open: false }));
    }, []);

    return (
        <ConfirmContext.Provider value={{ confirm }}>
            {children}
            {state.open && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50" aria-modal="true" role="dialog">
                    <div
                        className="w-full max-w-md rounded-2xl shadow-xl p-6 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{state.title}</h3>
                        <p className="text-gray-600 dark:text-gray-300 text-sm mb-6">{state.message}</p>
                        <div className="flex gap-3 justify-end">
                            <button
                                type="button"
                                onClick={() => handleClose(false)}
                                className="px-4 py-2.5 rounded-xl text-sm font-medium bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-slate-600 transition"
                            >
                                {state.cancelLabel}
                            </button>
                            <button
                                type="button"
                                onClick={() => handleClose(true)}
                                className={`px-4 py-2.5 rounded-xl text-sm font-medium text-white transition ${state.variant === 'danger'
                                    ? 'bg-red-600 hover:bg-red-700'
                                    : 'bg-emerald-600 hover:bg-emerald-700'
                                    }`}
                            >
                                {state.confirmLabel}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </ConfirmContext.Provider>
    );
}

export function useConfirm() {
    const ctx = useContext(ConfirmContext);
    if (!ctx) throw new Error('useConfirm must be used within ConfirmProvider');
    return ctx;
}
